import { Container } from 'react-bootstrap';
import AppHeader from '../../../components/AppHeader';
import Button from '../../../components/Button';
import { ButtonContainer } from '../../../components/Form';
import Loader from '../../../components/Loader';
import OpacityAnimation from '../../../components/OpacityAnimation';
import PageHeader from '../../../components/PageHeader';
import Sidebar from '../../../components/Sidebar';
import Transitions from '../../../components/Transition';
import useGetGeneralAppData from '../../../hooks/useGetGeneralAppData';
import AffreightmentAccessControlSettingsTab from './components/AffreightmentAccessControlSettingsTab';
import ApiIntegrationsSettingsTab from './components/ApiIntegrationsSettingsTab';
import CustomLogoTab from './components/CustomLogoTab';
import EmailsSettingsTab from './components/EmailsSettingsTab';
import FinancialSettingsTab from './components/FinancialSettingsTab';
import GeneralSettingsTab from './components/GeneralSettingsTab';
import MyLinkSettingsTab from './components/MyLinkSettingsTab';
import RoutingProcessSettingsTab from './components/RoutingProcessSettingsTab';
import TabsOptions from './components/TabsOptions';
import useSettings from './useSettings';

export default function Settings() {
  const {
    handleChangeActiveTab,
    activeTab,
    companyName,
    setAddExtractEmailModalShow,
    hasExtractEmailsToBeRendered,
    extractEmails,
    setExtractEmailToRemove,
    setRemoveExtractEmailModalShow,
    extractEmailToRemove,
    removeExtractEmail,
    addExtractEmailModalShow,
    extractEmailToAdd,
    handleExtractEmailToAddChange,
    addExtractEmail,
    removeExtractEmailModalShow,
    resetExtractEmails,
    hasOriginalExtractEmailsChanged,
    setAddRoutingNoResultEmailModalShow,
    hasRoutingNoResultEmailsToBeRendered,
    routingNoResultEmails,
    setRoutingNoResultEmailToRemove,
    setRemoveRoutingNoResultEmailModalShow,
    routingNoResultEmailToRemove,
    removeRoutingNoResultEmail,
    addRoutingNoResultEmailModalShow,
    routingNoResultEmailToAdd,
    handleRoutingNoResultEmailToAddChange,
    addRoutingNoResultEmail,
    removeRoutingNoResultEmailModalShow,
    resetRoutingNoResultEmails,
    hasOriginalRoutingNoResultEmailsChanged,
    setAddRoutingEmailModalShow,
    hasRoutingEmailsToBeRendered,
    routingEmails,
    setRoutingEmails,
    setRoutingEmailToRemove,
    setRemoveRoutingEmailModalShow,
    routingEmailToRemove,
    removeRoutingEmail,
    addRoutingEmailModalShow,
    routingEmailToAdd,
    handleRoutingEmailToAddChange,
    addRoutingEmail,
    removeRoutingEmailModalShow,
    resetRoutingEmails,
    hasOriginalRoutingEmailsChanged,
    willIntegrateWithPayroll,
    setWillIntegrateWithPayroll,
    technology,
    setTechnology,
    technologyOptions,
    losesOwnershipWithoutBoarding,
    daysAllowedWithoutBoarding,
    handleDaysAllowedWithoutBoardingChange,
    getErrorMessageByFieldName,
    sendAnswerOfClaimToCollabEmail,
    setSendAnswerOfClaimToCollabEmail,
    allowCollabToSeeLetter,
    setAllowCollabToSeeLetter,
    allowMultipleConsults,
    setAllowMultipleConsults,
    usesCustomLogo,
    setUsesCustomLogo,
    integrateWithWs,
    setIntegrateWithWs,
    handleLosesOwnershipWithoutBoardingChange,
    usaHorarioFretado,
    setUsaHorarioFretado,
    vtProvider,
    setVtProvider,
    vtProviderOptions,
    vtPurchaseProvider,
    setVtPurchaseProvider,
    hasCustomLogo,
    setHasCustomLogo,
    showTicketsAtNotOptimizedResults,
    setShowTicketsAtNotOptimizedResults,
    hasCustomTextAtLetter,
    handleHasCustomTextAtLetterChange,
    customTextAtLetter,
    handleCustomTextAtLetterChange,
    partner,
    setPartner,
    partnerOptions,
    secondPartner,
    setSecondPartner,
    secondPartnerOptions,
    directResult,
    setDirectResult,
    maxContestsAllowed,
    setMaxContestsAllowed,
    copyGoingToReturn,
    setCopyGoingToReturn,
    hasAffreightment,
    setHasAffreightment,
    hasKmLimit,
    setHasKmLimit,
    selectedKmLimit,
    setSelectedKmLimit,
    selectedWalkDistance,
    setSelectedWalkDistance,
    transfersBehavior,
    setTransfersBehavior,
    compareWithDesiredVtValue,
    desiredVtValue,
    utilizaTetoValorPadraoEmp,
    setUtilizaTetoValorPadraoEmp,
    chooseDefaultValueForRoutings,
    defaultValueForRoutings,
    kindOfVtSpTrans,
    setKindOfVtSpTrans,
    handleKmLimitSelection,
    handleWalkDistanceSelection,
    handleCompareWithDesiredVtValueChange,
    handleDesiredVtValueChange,
    handleChooseDefaultValueForRoutingsChange,
    handleDefaultValueForRoutingsChange,
    extractEmailOwnerNameToAdd,
    handleExtractEmailOwnerNameToAddChange,
    routingEmailOwnerNameToAdd,
    handleRoutingEmailOwnerNameToAddChange,
    routingNoResultEmailOwnerNameToAdd,
    handleRoutingNoResultEmailOwnerNameToAddChange,
    isLoading,
    uploadImage,
    imageFile,
    setImageFile,
    setupCompany,
    areSettingsValid,
    tabsDisabled,
    setIsMyLinkFull,
    isMyLinkFull,
    defaultWorkplaceUsesIntegrationWs,
    setDefaultWorkplaceUsesIntegrationWs,
    changesWpDataByWs,
    setChangesWpDataByWs,
    isPartner,
    setIsPartner,
    usesLogoAtEmail,
    setUsesLogoAtEmail,
    verifySalaryRJ,
    setVerifySalaryRJ,
    vtItensRelationsRequestEmailOwnerNameToAdd,
    handleVtItensRelationsRequestEmailOwnerNameToAddChange,
    addVtItensRelationsRequestEmail,
    removeVtItensRelationsRequestEmailModalShow,
    resetVtItensRelationsRequestEmails,
    hasOriginalVtItensRelationsRequestEmailsChanged,
    vtItensRelationsRequestEmails,
    vtItensRelationsRequestEmailToAdd,
    handleVtItensRelationsRequestEmailToAddChange,
    vtItensRelationsRequestEmailToRemove,
    setVtItensRelationsRequestEmailToRemove,
    setRemoveVtItensRelationsRequestEmailModalShow,
    removeVtItensRelationsRequestEmail,
    addVtItensRelationsRequestEmailModalShow,
    setAddVtItensRelationsRequestEmailModalShow,
    hasVtItensRelationsRequestEmailsToBeRendered,
    financialEmailOwnerNameToAdd,
    handleFinancialEmailOwnerNameToAddChange,
    addFinancialEmail,
    removeFinancialEmailModalShow,
    resetFinancialEmails,
    hasOriginalFinancialEmailsChanged,
    financialEmails,
    financialEmailToAdd,
    handleFinancialEmailToAddChange,
    financialEmailToRemove,
    setFinancialEmailToRemove,
    setRemoveFinancialEmailModalShow,
    removeFinancialEmail,
    addFinancialEmailModalShow,
    setAddFinancialEmailModalShow,
    hasFinancialEmailsToBeRendered,
    canRequestVtItemRelation,
    setCanRequestVtItemRelation,
    hasWebhook,
    setHasWebhook,
    kindOfVtAesa,
    setKindOfVtAesa,
    aboveDesiredValueReturnsBiasTag,
    setAboveDesiredValueReturnsBiasTag,
    hasResultReadyWebhook,
    setHasResultReadyWebhook,
    hasResultOutOfScopeWebhook,
    setHasResultOutOfScopeWebhook,
    integrator,
    setIntegrator,
    particularities,
    setParticularities,
    mustSendAddressProof,
    setMustSendAddressProof,
    usaRodoviarioValZero,
    setUsaRodoviarioValZero,
    kmRodoviarioValZero,
    setKmRodoviarioValZero,
    geraNFSeparada,
    setGeraNFSeparada,
    geraNFSeparadaMatriz,
  } = useSettings();
  const { permissions, companiesList, companyCode } = useGetGeneralAppData();
  const pagePermissions = permissions.find((x) => x.codPag === 2);
  const canEdit = pagePermissions?.alterar || pagePermissions?.incluir;
  const selectedCompanyInList = companiesList.flatMap((group) => group.options).find((opt) => opt.value === companyCode);
  const isFilial = selectedCompanyInList?.type === 'F';

  return (
    <>
      <AppHeader isCompanySelectedDisabled={false} />
      <Sidebar active="Company" />
      <Loader isLoading={isLoading} />
      <Transitions>
        <PageHeader
          title={`Configurações ${companyName}`}
          link="/company"
        />
        <TabsOptions handleChangeActiveTab={handleChangeActiveTab} activeTab={activeTab} tabsDisabled={tabsDisabled} />
        <Container>
          {activeTab === 'routingRules' && (
            <OpacityAnimation>
              <RoutingProcessSettingsTab
                copyGoingToReturn={copyGoingToReturn}
                setCopyGoingToReturn={setCopyGoingToReturn}
                hasAffreightment={hasAffreightment}
                setHasAffreightment={setHasAffreightment}
                hasKmLimit={hasKmLimit}
                setHasKmLimit={setHasKmLimit}
                selectedKmLimit={selectedKmLimit}
                setSelectedKmLimit={setSelectedKmLimit}
                selectedWalkDistance={selectedWalkDistance}
                setSelectedWalkDistance={setSelectedWalkDistance}
                transfersBehavior={transfersBehavior}
                setTransfersBehavior={setTransfersBehavior}
                compareWithDesiredVtValue={compareWithDesiredVtValue}
                desiredVtValue={desiredVtValue}
                chooseDefaultValueForRoutings={chooseDefaultValueForRoutings}
                defaultValueForRoutings={defaultValueForRoutings}
                kindOfVtSpTrans={kindOfVtSpTrans}
                setKindOfVtSpTrans={setKindOfVtSpTrans}
                handleKmLimitSelection={handleKmLimitSelection}
                handleWalkDistanceSelection={handleWalkDistanceSelection}
                handleCompareWithDesiredVtValueChange={handleCompareWithDesiredVtValueChange}
                handleDesiredVtValueChange={handleDesiredVtValueChange}
                handleChooseDefaultValueForRoutingsChange={handleChooseDefaultValueForRoutingsChange}
                handleDefaultValueForRoutingsChange={handleDefaultValueForRoutingsChange}
                getErrorMessageByFieldName={getErrorMessageByFieldName}
                kindOfVtAesa={kindOfVtAesa}
                setKindOfVtAesa={setKindOfVtAesa}
                aboveDesiredValueReturnsBiasTag={aboveDesiredValueReturnsBiasTag}
                setAboveDesiredValueReturnsBiasTag={setAboveDesiredValueReturnsBiasTag}
                usaRodoviarioValZero={usaRodoviarioValZero}
                setUsaRodoviarioValZero={setUsaRodoviarioValZero}
                kmRodoviarioValZero={kmRodoviarioValZero}
                setKmRodoviarioValZero={setKmRodoviarioValZero}
                utilizaTetoValorPadraoEmp={utilizaTetoValorPadraoEmp}
                setUtilizaTetoValorPadraoEmp={setUtilizaTetoValorPadraoEmp}
              />
            </OpacityAnimation>
          )}

          {activeTab === 'generalSettings' && (
            <OpacityAnimation>
              <GeneralSettingsTab
                vtProvider={vtProvider}
                setVtProvider={setVtProvider}
                vtProviderOptions={vtProviderOptions}
                vtPurchaseProvider={vtPurchaseProvider}
                setVtPurchaseProvider={setVtPurchaseProvider}
                hasCustomLogo={hasCustomLogo}
                setHasCustomLogo={setHasCustomLogo}
                showTicketsAtNotOptimizedResults={showTicketsAtNotOptimizedResults}
                setShowTicketsAtNotOptimizedResults={setShowTicketsAtNotOptimizedResults}
                hasCustomTextAtLetter={hasCustomTextAtLetter}
                handleHasCustomTextAtLetterChange={handleHasCustomTextAtLetterChange}
                customTextAtLetter={customTextAtLetter}
                handleCustomTextAtLetterChange={handleCustomTextAtLetterChange}
                partner={partner}
                setPartner={setPartner}
                partnerOptions={partnerOptions}
                secondPartner={secondPartner}
                setSecondPartner={setSecondPartner}
                secondPartnerOptions={secondPartnerOptions}
                directResult={directResult}
                setDirectResult={setDirectResult}
                maxContestsAllowed={maxContestsAllowed}
                setMaxContestsAllowed={setMaxContestsAllowed}
                getErrorMessageByFieldName={getErrorMessageByFieldName}
                defaultWorkplaceUsesIntegrationWs={defaultWorkplaceUsesIntegrationWs}
                setDefaultWorkplaceUsesIntegrationWs={setDefaultWorkplaceUsesIntegrationWs}
                changesWpDataByWs={changesWpDataByWs}
                setChangesWpDataByWs={setChangesWpDataByWs}
                isPartner={isPartner}
                setIsPartner={setIsPartner}
                usesLogoAtEmail={usesLogoAtEmail}
                setUsesLogoAtEmail={setUsesLogoAtEmail}
                canRequestVtItemRelation={canRequestVtItemRelation}
                setCanRequestVtItemRelation={setCanRequestVtItemRelation}
                particularities={particularities}
                setParticularities={setParticularities}
              />
            </OpacityAnimation>
          )}

          {activeTab === 'myLink' && (
            <OpacityAnimation>
              <MyLinkSettingsTab
                sendAnswerOfClaimToCollabEmail={sendAnswerOfClaimToCollabEmail}
                setSendAnswerOfClaimToCollabEmail={setSendAnswerOfClaimToCollabEmail}
                allowCollabToSeeLetter={allowCollabToSeeLetter}
                setAllowCollabToSeeLetter={setAllowCollabToSeeLetter}
                allowMultipleConsults={allowMultipleConsults}
                setAllowMultipleConsults={setAllowMultipleConsults}
                usesCustomLogo={usesCustomLogo}
                setUsesCustomLogo={setUsesCustomLogo}
                integrateWithWs={integrateWithWs}
                setIntegrateWithWs={setIntegrateWithWs}
                setIsMyLinkFull={setIsMyLinkFull}
                isMyLinkFull={isMyLinkFull}
                verifySalaryRJ={verifySalaryRJ}
                setVerifySalaryRJ={setVerifySalaryRJ}
                mustSendAddressProof={mustSendAddressProof}
                setMustSendAddressProof={setMustSendAddressProof}
              />
            </OpacityAnimation>
          )}

          {activeTab === 'accessControlAffreightment' && (
            // <AccessControlAffreightmentSettingsTab />
            <OpacityAnimation>
              <AffreightmentAccessControlSettingsTab
                losesOwnershipWithoutBoarding={losesOwnershipWithoutBoarding}
                daysAllowedWithoutBoarding={daysAllowedWithoutBoarding}
                handleDaysAllowedWithoutBoardingChange={handleDaysAllowedWithoutBoardingChange}
                handleLosesOwnershipWithoutBoardingChange={handleLosesOwnershipWithoutBoardingChange}
                getErrorMessageByFieldName={getErrorMessageByFieldName}
                usaHorarioFretado={usaHorarioFretado}
                setUsaHorarioFretado={setUsaHorarioFretado}
              />
            </OpacityAnimation>
          )}

          {activeTab === 'apiIntegrations' && (
            // <AccessControlAffreightmentSettingsTab />
            <OpacityAnimation>
              <ApiIntegrationsSettingsTab
                willIntegrateWithPayroll={willIntegrateWithPayroll}
                setWillIntegrateWithPayroll={setWillIntegrateWithPayroll}
                technology={technology}
                setTechnology={setTechnology}
                technologyOptions={technologyOptions}
                hasWebhook={hasWebhook}
                setHasWebhook={setHasWebhook}
                hasResultReadyWebhook={hasResultReadyWebhook}
                setHasResultReadyWebhook={setHasResultReadyWebhook}
                hasResultOutOfScopeWebhook={hasResultOutOfScopeWebhook}
                setHasResultOutOfScopeWebhook={setHasResultOutOfScopeWebhook}
                integrator={integrator}
                setIntegrator={setIntegrator}
                partnerOptions={partnerOptions}
              />
            </OpacityAnimation>
          )}

          {activeTab === 'emails' && (
            <OpacityAnimation>
              <EmailsSettingsTab
                setAddExtractEmailModalShow={setAddExtractEmailModalShow}
                hasExtractEmailsToBeRendered={hasExtractEmailsToBeRendered}
                extractEmails={extractEmails}
                setExtractEmailToRemove={setExtractEmailToRemove}
                setRemoveExtractEmailModalShow={setRemoveExtractEmailModalShow}
                extractEmailToRemove={extractEmailToRemove}
                removeExtractEmail={removeExtractEmail}
                addExtractEmailModalShow={addExtractEmailModalShow}
                extractEmailToAdd={extractEmailToAdd}
                handleExtractEmailToAddChange={handleExtractEmailToAddChange}
                addExtractEmail={addExtractEmail}
                removeExtractEmailModalShow={removeExtractEmailModalShow}
                resetExtractEmails={resetExtractEmails}
                hasOriginalExtractEmailsChanged={hasOriginalExtractEmailsChanged}
                setAddRoutingNoResultEmailModalShow={setAddRoutingNoResultEmailModalShow}
                hasRoutingNoResultEmailsToBeRendered={hasRoutingNoResultEmailsToBeRendered}
                routingNoResultEmails={routingNoResultEmails}
                setRoutingNoResultEmailToRemove={setRoutingNoResultEmailToRemove}
                setRemoveRoutingNoResultEmailModalShow={setRemoveRoutingNoResultEmailModalShow}
                routingNoResultEmailToRemove={routingNoResultEmailToRemove}
                removeRoutingNoResultEmail={removeRoutingNoResultEmail}
                addRoutingNoResultEmailModalShow={addRoutingNoResultEmailModalShow}
                routingNoResultEmailToAdd={routingNoResultEmailToAdd}
                handleRoutingNoResultEmailToAddChange={handleRoutingNoResultEmailToAddChange}
                addRoutingNoResultEmail={addRoutingNoResultEmail}
                removeRoutingNoResultEmailModalShow={removeRoutingNoResultEmailModalShow}
                resetRoutingNoResultEmails={resetRoutingNoResultEmails}
                hasOriginalRoutingNoResultEmailsChanged={hasOriginalRoutingNoResultEmailsChanged}
                setAddRoutingEmailModalShow={setAddRoutingEmailModalShow}
                hasRoutingEmailsToBeRendered={hasRoutingEmailsToBeRendered}
                routingEmails={routingEmails}
                setRoutingEmails={setRoutingEmails}
                setRoutingEmailToRemove={setRoutingEmailToRemove}
                setRemoveRoutingEmailModalShow={setRemoveRoutingEmailModalShow}
                routingEmailToRemove={routingEmailToRemove}
                removeRoutingEmail={removeRoutingEmail}
                addRoutingEmailModalShow={addRoutingEmailModalShow}
                routingEmailToAdd={routingEmailToAdd}
                handleRoutingEmailToAddChange={handleRoutingEmailToAddChange}
                addRoutingEmail={addRoutingEmail}
                removeRoutingEmailModalShow={removeRoutingEmailModalShow}
                resetRoutingEmails={resetRoutingEmails}
                hasOriginalRoutingEmailsChanged={hasOriginalRoutingEmailsChanged}
                extractEmailOwnerNameToAdd={extractEmailOwnerNameToAdd}
                handleExtractEmailOwnerNameToAddChange={handleExtractEmailOwnerNameToAddChange}
                routingEmailOwnerNameToAdd={routingEmailOwnerNameToAdd}
                handleRoutingEmailOwnerNameToAddChange={handleRoutingEmailOwnerNameToAddChange}
                routingNoResultEmailOwnerNameToAdd={routingNoResultEmailOwnerNameToAdd}
                handleRoutingNoResultEmailOwnerNameToAddChange={handleRoutingNoResultEmailOwnerNameToAddChange}
                vtItensRelationsRequestEmailOwnerNameToAdd={vtItensRelationsRequestEmailOwnerNameToAdd}
                handleVtItensRelationsRequestEmailOwnerNameToAddChange={handleVtItensRelationsRequestEmailOwnerNameToAddChange}
                addVtItensRelationsRequestEmail={addVtItensRelationsRequestEmail}
                removeVtItensRelationsRequestEmailModalShow={removeVtItensRelationsRequestEmailModalShow}
                resetVtItensRelationsRequestEmails={resetVtItensRelationsRequestEmails}
                hasOriginalVtItensRelationsRequestEmailsChanged={hasOriginalVtItensRelationsRequestEmailsChanged}
                vtItensRelationsRequestEmails={vtItensRelationsRequestEmails}
                vtItensRelationsRequestEmailToAdd={vtItensRelationsRequestEmailToAdd}
                handleVtItensRelationsRequestEmailToAddChange={handleVtItensRelationsRequestEmailToAddChange}
                vtItensRelationsRequestEmailToRemove={vtItensRelationsRequestEmailToRemove}
                setVtItensRelationsRequestEmailToRemove={setVtItensRelationsRequestEmailToRemove}
                setRemoveVtItensRelationsRequestEmailModalShow={setRemoveVtItensRelationsRequestEmailModalShow}
                removeVtItensRelationsRequestEmail={removeVtItensRelationsRequestEmail}
                addVtItensRelationsRequestEmailModalShow={addVtItensRelationsRequestEmailModalShow}
                setAddVtItensRelationsRequestEmailModalShow={setAddVtItensRelationsRequestEmailModalShow}
                hasVtItensRelationsRequestEmailsToBeRendered={hasVtItensRelationsRequestEmailsToBeRendered}
                financialEmailOwnerNameToAdd={financialEmailOwnerNameToAdd}
                handleFinancialEmailOwnerNameToAddChange={handleFinancialEmailOwnerNameToAddChange}
                addFinancialEmail={addFinancialEmail}
                removeFinancialEmailModalShow={removeFinancialEmailModalShow}
                resetFinancialEmails={resetFinancialEmails}
                hasOriginalFinancialEmailsChanged={hasOriginalFinancialEmailsChanged}
                financialEmails={financialEmails}
                financialEmailToAdd={financialEmailToAdd}
                handleFinancialEmailToAddChange={handleFinancialEmailToAddChange}
                financialEmailToRemove={financialEmailToRemove}
                setFinancialEmailToRemove={setFinancialEmailToRemove}
                setRemoveFinancialEmailModalShow={setRemoveFinancialEmailModalShow}
                removeFinancialEmail={removeFinancialEmail}
                addFinancialEmailModalShow={addFinancialEmailModalShow}
                setAddFinancialEmailModalShow={setAddFinancialEmailModalShow}
                hasFinancialEmailsToBeRendered={hasFinancialEmailsToBeRendered}
              />
            </OpacityAnimation>
          )}

          {activeTab === 'customLogo' && (
            <OpacityAnimation>
              <CustomLogoTab
                imageFile={imageFile}
                setImageFile={setImageFile}
              />
            </OpacityAnimation>
          )}

          {activeTab === 'financial' && (
            <OpacityAnimation>
              <FinancialSettingsTab
                geraNFSeparada={geraNFSeparada}
                setGeraNFSeparada={setGeraNFSeparada}
                geraNFSeparadaMatriz={geraNFSeparadaMatriz}
                isFilial={!!isFilial}
              />
            </OpacityAnimation>
          )}

          <ButtonContainer>
            {activeTab === 'customLogo' ? (
              <Button onClick={() => uploadImage()} disabled={!imageFile || !canEdit}>
                Salvar logomarca
              </Button>
            ) : (
              <Button onClick={() => setupCompany({ logo: false })} disabled={!areSettingsValid || !canEdit}>
                Salvar configurações
              </Button>
            )}
          </ButtonContainer>
        </Container>
      </Transitions>
    </>
  );
}
